<template>
    <ul class="action action--buttons" v-if="getItems.length >= 1">
        <template v-for="item in getItems">
            <li class="action--buttons__item">
                <template v-if="item.router">
                    <router-link :to="item.router" class="button button--action" :class="item.class" :title="item.title" :disabled="isDisabled && ['activate', 'deactivate', 'cancel'].indexOf(item.action) === -1" tabindex="-1">
                        <span>{{ item.title }}</span>
                    </router-link>
                </template>
                <template v-else>
                    <button role="button" class="button button--action" :class="item.class" :title="item.title" :disabled="isDisabled && ['activate', 'deactivate', 'cancel'].indexOf(item.action) === -1" tabindex="-1" @click="onClickAction(item.action)">
                        <span>{{ item.title }}</span>
                    </button>
                </template>
            </li>
        </template>
    </ul>
</template>

<script>
    export default {
        props : {
            items : {
                type : Array,
                default : () => []
            },
            isDisabled : {
                type : Boolean,
                default : false
            }
        },
        computed : {
            getItems : function () {
                var items = [];

                this.items.forEach((function (item) {
                    if (typeof item === 'object') {
                        var action = item;
                    } else {
                        var action = {
                            action  : item
                        };
                    }

                    if (action.action) {
                        if (!action.title || action.title === '') {
                            action.title = this.$t(action.action.replace('-', '_'));
                        }

                        if (!action.class || action.class === '') {
                            action.class = 'button--action--' + action.action;
                        }

                        items.push(action);
                    }
                }).bind(this));

                return items;
            }
        },
        methods : {
            onClickAction : function (action) {
                this.$emit('actionClicked', action);
            }
        }
    }
</script>